import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsAvgAgePerDomainWidgetComponent } from './tractors-avg-age-per-domain-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsAvgAgePerDomainWidgetComponent],
    imports: [
        CommonModule,
        DxChartModule
    ],
  exports: [TractorsAvgAgePerDomainWidgetComponent]
})
export class TractorsAvgAgePerDomainWidgetModule { }
